export class Notification {
  id: string;
  message: string;
  title?: string;
  type?: string;
  date?: string;
}
